import { Component, Input, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import {
  OrderDetails,
  OrderStatus,
  OrdersData,
} from 'src/app/stores/orders.store';
import { currencyCode, imageUrl } from 'src/environments/environment';

@Component({
  selector: 'app-order-confirm',
  templateUrl: './order-confirm.component.html',
  styleUrls: ['./order-confirm.component.scss'],
})
export class OrderConfirmComponent implements OnInit {
  @Input() ordersDetail: OrdersData;
  imageUrl = imageUrl;
  currencyCode = currencyCode;
  OrderStatus = OrderStatus;
  @Input() isAssign: boolean = false;
  @Input() isConfirm: boolean = false;

  @Input() assignDelivery;
  @Input() confirmDelivery;
  constructor(public platform: Platform) {
    console.log('isAssign', this.isAssign);
  }

  ngOnInit() {}
}
